import { render, staticRenderFns } from "./CASEJSONView.vue?vue&type=template&id=07de2b10"
import script from "./CASEJSONView.vue?vue&type=script&lang=js"
export * from "./CASEJSONView.vue?vue&type=script&lang=js"
import style0 from "./CASEJSONView.vue?vue&type=style&index=0&id=07de2b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports